var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('keep-alive',[_c('Recent')],1),_c('keep-alive',[_c('Lesson')],1),_c('keep-alive',[_c('Course')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }